

import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    selected: {
        borderRadius: '1px',

        backgroundColor: 'rgba(0, 123, 255, 0.5) !important',
        color: 'white',
        '&:hover': {
            backgroundColor: 'red !important',
        },
    },
});
const MultipleDropDown = ({ data, setValue, value }) => {
    const classes = useStyles();

    return (
        <FormControl variant="standard" style={{ maxWidth: '375px', width: '100%' }}>
            <InputLabel id="multiple-tags-label">Tags</InputLabel>
            <Select
                labelId="multiple-tags-label"
                id="tags"
                name="tags"
                multiple // Allow multiple selection
                value={value}
                onChange={setValue}
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: '200px',
                            overflow: 'auto',
                            padding: '10px',
                            borderRadius: '10px'

                        },
                    },
                }}
            // Add other necessary props
            >
                {data.map((tag) => (
                    <MenuItem key={tag.id} value={tag.id} style={{ display: 'block' }} classes={{ selected: classes.selected }}
                    >
                        {tag.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default MultipleDropDown;